import { createSuccess as appointmentCreateSuccess } from 'FRONTEND/reducers/appointmentSlice';
import {
  pickDuration,
  pickType,
  updateAvailableTypeList,
  updateIsPatientNotifEnabled,
  pickLocation,
  pickExpert,
  pickPatient,
  pickDateTime,
  updateReason,
  pickSlot,
  clearForm,
  formCleared,
  pickDesiredConsultationCode,
  updateHasPayment,
  updatePayLater,
} from 'FRONTEND/reducers/bookingSlice';
import {
  eventKindFilterChange,
  goToMultipleCalendar,
  goToActorCalendar,
  goToActorSettings,
  goBackToForm,
  goToGivenExpertForm,
  goToGivenSlotForm,
  typeFilterChange,
  goToLocationForm,
  goToUnrestrictedForm,
  changeCalendarView,
} from 'FRONTEND/reducers/calendarSlice';
import { check, unCheck, clearSearch as clearExpertSearch } from 'FRONTEND/reducers/expertSlice';
import { clearSearch as clearPatientSearch } from 'FRONTEND/reducers/patientSlice';
import { hideRightPanel, showRightPanel } from 'FRONTEND/reducers/rightPanelSlice';
import { clear } from 'FRONTEND/reducers/slotSlice';
import { updateTableFilters, updateTableContext, applyTableSearch } from 'FRONTEND/reducers/tableSlice';
import { storePreference } from 'FRONTEND/utils/localStorage';
import { filterSensitiveData, resetDeserializedState } from 'FRONTEND/utils/serialization';

const serializationMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case updateAvailableTypeList.toString():
    case pickType.toString():
    case pickDuration.toString():
    case pickLocation.toString():
    case pickPatient.toString():
    case pickExpert.toString():
    case pickSlot.toString():
    case pickDateTime.toString():
    case pickDesiredConsultationCode.toString():
    case clearPatientSearch.toString():
    case clearExpertSearch.toString():
    case clearForm.toString():
    case formCleared.toString():
    case clear.toString():
    case goToGivenSlotForm.toString():
    case goToGivenExpertForm.toString():
    case goToLocationForm.toString():
    case goToUnrestrictedForm.toString():
    case goBackToForm.toString():
    case goToActorCalendar.toString():
    case goToActorSettings.toString():
    case goToMultipleCalendar.toString():
    case check.toString():
    case unCheck.toString():
    case typeFilterChange.toString():
    case eventKindFilterChange.toString():
    case updateIsPatientNotifEnabled.toString():
    case updateReason.toString():
    case updateHasPayment.toString():
    case updatePayLater.toString():
    case changeCalendarView.toString():
    case hideRightPanel.toString():
    case appointmentCreateSuccess.toString():
    case showRightPanel.toString():
    case applyTableSearch.toString():
    case updateTableContext.toString():
    case updateTableFilters.toString(): {
      next(action);
      const state = store.getState();
      storePreference(state.user.id, 'reduxStore', filterSensitiveData(state));
      resetDeserializedState();
      return;
    }
    default:
      return next(action);
  }
};

export default serializationMiddleware;
